import * as landing from './landing/actions';

export const templateActions = { landing };
